import { Box, Button, Typography } from '@mui/material';
import { theme } from '../../../utils/theme/godzilla_light';

const styles = {
    formWrapper: {
        p: "2.5rem",
        boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)',
        backgroundColor: "#fff",
        borderRadius: "8px",
        maxWidth: "43rem",
        width: '31rem'
    },
    pageTitleStyle: {
        ...theme.typography.opticianBodyRegular,
        fontSize: "2rem",
    },
    buttonWrapper: {
        mt: '16px',
        px: '1.372rem'
    },
    buttonLabel: {
        ...theme.typography.poppinsBodySemiBold,
        fontSize: "1rem",
        color: "#fff"
    }
}

interface IInfoCardHOCProps {
    infoTitle: string;
    buttonText: string;
    onClickBtn?: () => void;
    rightBtnElement?: any;
    children: React.ReactNode;
    buttonSx?: any;
    iconComponent?: any;
}

export const InformationCardHOC = (props: IInfoCardHOCProps) => {
    const { children, infoTitle, buttonText, onClickBtn, rightBtnElement, buttonSx, iconComponent } = props
    return (
        <Box sx={styles.formWrapper}>
            {iconComponent}
            <Typography sx={styles.pageTitleStyle}>{infoTitle}</Typography>
            {children}
            <Button
                onClick={onClickBtn}
                variant='contained'
                sx={{
                    ...theme.button.contained.primary,
                    ...styles.buttonWrapper,
                    ...buttonSx
                }}>
                <Typography sx={styles.buttonLabel}>{buttonText}</Typography>
                {rightBtnElement}
            </Button>
        </Box>
    );
}